<template>
  <v-container fluid class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-select
          v-show="!!result"
          solo
          flat
          :items="stats"
          v-model="selectedStat"
          prepend-inner-icon="graphic_eq"
          append-icon="keyboard_arrow_down"
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs12>
          <v-scale-transition>
            <div id="chart" ref="grafica" style="width: 100%;" v-show="!!result"></div>
          </v-scale-transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Highcharts from 'highcharts'
import seriesLabel from 'highcharts/modules/series-label'
import exportHighcharts from 'highcharts/modules/exporting'
import setDarkTheme from 'highcharts/js/themes/dark-unica'
import setLightTheme from 'highcharts/js/themes/sand-signika'

import moment from 'moment'

import getChartConfig from '.'

import config from '@/config'

// Inicialización Highcarts para exportar
exportHighcharts(Highcharts)

window.addEventListener('mouseover', event => {
  if(checkClass(event.target, 4, 'highcharts-legend')) {
    document.querySelector('.highcharts-tooltip').style.visibility = 'hidden'
  }
})

window.addEventListener('mouseout', event => {
  if(checkClass(event.target, 4, 'highcharts-legend')) {
    document.querySelector('.highcharts-tooltip').style.visibility = 'visible'
  }
})

function checkClass(element, depth, className, actualDepth = 0) {
  if(!element) {
    return false
  }

  const classList = [...element.classList]

  if(classList.some(cls => cls.startsWith(className))) {
    return true
  }

  return checkClass(element.parentElement, depth, className, actualDepth++)
}

/**
 * Componente para mostar gráfica a partir de los resultados (datos)
 */
export default {
  props: ['result', 'rasters'],
  data() {
    return {
      chart: null,
      difference: null,
      stats: ['avg', 'min', 'max'],
      selectedStat: 'avg',
      mouseOutChart: null,
      GetChartConfig: getChartConfig.bind(this)
    }
  },

  created() {
    this.$watch(() => this.$store.getters.isDarkTheme, this.setGraphTheme)
    this.$watch(() => this.$store.getters.locale, this.onLocaleChange)
  },

  mounted() {
    this.setGraphTheme()
  },

  computed: {
    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },

    period() {
      return this.$store.getters.period
    },

    indicador() {
      return this.$store.getters.indicador
    },

  },

  methods: {
    setGraphTheme() {
      const darkTheme = this.$store.getters.isDarkTheme

      if(darkTheme) {
        setDarkTheme(Highcharts)
      } else {
        setLightTheme(Highcharts)
      }
      
      if(!this.result) {
        return
      }
      
      this.createChart()
    },

    createChart() {
      const graph = this.$refs.grafica
      const period = this.period
      const rasters = this.rasters

      const data = this.result
        .map(([value, stats], index) => 
          [rasters[index].name, +value 
            ? +value.toFixed(2)
            : null, +stats[this.selectedStat] ? +stats[this.selectedStat].toFixed(2) : null])
        .map(([layerName, value, stat]) => 
          value < -3e38 
            ? [layerName, null, stat]
            : [layerName, value, stat] )
        .reverse()


      const onSelect = (layerName) => {
        const workspace = config.geoserver.geoserverWorkspace
        this.raster = rasters.find(r => r.name == `${workspace}:${layerName}`)
      }

      const chartConfig = this.GetChartConfig(data, this.indicador, period, this.$store.getters.isDarkTheme, onSelect)

      this.chart = Highcharts.chart(graph, chartConfig, chart => chart.reflow())
    },

    onLocaleChange(locale) {
      const months = moment.localeData(locale.key).months().map(m => m.toLowerCase())
      const monthsDisplay = months.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

      Highcharts.setOptions({
        lang: {
          months: monthsDisplay,
          shortMonths: monthsDisplay.map(str => str.slice(0, 3))
        }
      })

      if(this.result) {
        this.createChart()
      }
    }
  },

  watch: {
    result() {
      if(this.result) {
        this.createChart()
      }
      
      this.difference = null
    },
    selectedStat() {
      this.createChart()
    },
  }
}
</script>



// WEBPACK FOOTER //
// chart-search.vue?11005d78